import { getDataMapper, mapField } from "@/shared";

export const mapRentInventoryUnionToServer = getDataMapper({
    kit_id: mapField("kitId", Number),
    inventory_ids: mapField("inventoriesIds", Number),
});
